import { Injectable } from '@angular/core';
import { IEdlCfDisplayGenericService } from '@edl-development/edl-custom-forms';
import { PaetepCfSignatureModel } from '../../../item-models/paetep-cf-signature.model';
import { PaetepCfAnswerSignatureModel } from '../../../answer-models/paetep-cf-answer-signature.model';
import { AbstractControl, FormBuilder } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfSignatureService implements IEdlCfDisplayGenericService<PaetepCfSignatureModel, PaetepCfAnswerSignatureModel> {
  
    constructor(
        private formBuilder: FormBuilder
    ) { }

  public buildForm = ({ 
        model,
        answer
    }: { 
        model: PaetepCfSignatureModel;
        answer?: PaetepCfAnswerSignatureModel
    }) : AbstractControl | void => this.formBuilder.control(answer?.signature, []);

}
